import { useNavigate } from 'react-router-dom';
import { MYACCOUNT_MEMBERSHIPS_ROUTE } from '../../routes/namedRoutes';

/**
 * Single destination for every "Upgrade" call to action.
 *
 * The three call sites used to disagree: two gated the navigation behind the `membershipsPage`
 * flag and so did nothing at all while it was off, one navigated regardless, and one hid the
 * button. Now that Association members are newly eligible to see these CTAs (SN-996) the
 * tier-driven CTA is an acceptance criterion, so it stays visible, and a button that silently
 * does nothing is worse for support than any destination.
 *
 * So the CTA always renders and always navigates to the memberships page. That page renders
 * the not-found page while its flag is off, which is product's accepted trade-off: the flag is
 * expected to be on in production by release, and a visible dead end beats a dead button.
 */
export const useUpgradeNavigation = () => {
  const navigate = useNavigate();

  return {
    /** Navigates to the upgrade destination. Never a no-op. */
    navigateToUpgrade: () => navigate(MYACCOUNT_MEMBERSHIPS_ROUTE),
  };
};
